import BEMap from './BEMap';
export default BEMap;
